import { useTranslation } from 'react-i18next'
import { ListState, tdClass, thClass } from '@/components/admin/AdminShared'
import { useAdminAudit } from '@/hooks/useAdmin'
import { dateTimeLabel, viewerTimeZone } from '@/lib/threadView'

export function AdminAuditTab() {
  const { t } = useTranslation()
  const audit = useAdminAudit(true)
  const tz = viewerTimeZone()
  return (
    <ListState query={audit}>
      {audit.data && audit.data.length === 0 ? (
        <p className="py-6 text-meta text-ink-muted">{t('admin.empty')}</p>
      ) : (
        <table className="w-full border-collapse">
          <thead className="bg-surface-subtle">
            <tr>
              <th className={thClass}>{t('admin.auditCols.at')}</th>
              <th className={thClass}>{t('admin.auditCols.entity')}</th>
              <th className={thClass}>{t('admin.auditCols.action')}</th>
              <th className={thClass}>{t('admin.auditCols.actor')}</th>
              <th className={thClass}>{t('admin.auditCols.reason')}</th>
            </tr>
          </thead>
          <tbody>
            {audit.data?.map((e) => (
              <tr key={e.id} className="border-b border-line">
                <td className={`${tdClass} font-mono`}>{dateTimeLabel(e.at, tz)}</td>
                <td className={tdClass}>
                  <span className="text-ink-strong">{e.entityType}</span>{' '}
                  <span className="font-mono text-label text-ink-muted">{e.entityId.slice(0, 8)}</span>
                </td>
                <td className={tdClass}>{e.action}</td>
                <td className={tdClass}>{e.actorName ?? e.actorId.slice(0, 8)}</td>
                <td className={tdClass}>{e.reason ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </ListState>
  )
}
